export const findFirstFocusableElement = (formRef) => {
  const firstFormField = formRef?.current?.querySelector(
    'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
  );
  const mainHeading = document.querySelector(
    'h1[tabindex="-1"], h2[tabindex="-1"]'
  );
  const mainEl = document.querySelector('main[tabindex="-1"]');
  
  return firstFormField || mainHeading || mainEl;
};